import React, { useEffect } from "react";
import PropTypes from "prop-types";
import ForbiddenIcon from "assets/svgs/forbiddenIcon.svg";
import "./Table.scss";

const Table = (props) => {
  const {
    selectAllOptionEnabled,
    hideSelectAll,
    selectOptionEnabled,
    tableHeaders,
    rowElements,
    tableName,
    tooltipForbidden,
  } = props;

  useEffect(() => {
    Array.from(document.querySelectorAll('[data-bs-toggle="popover"]')).forEach(
      (el) => bootstrap.Popover.getOrCreateInstance(el).enable()
    );
  }, [tableName]);

  return (
    <div className={`${tableName} table-custom-component`}>
      <div className="table-head table-row">
        {selectAllOptionEnabled && !hideSelectAll ? (
          <>
            <div className="table-cell">
              <div className="input-group">
                <input
                  type="checkbox"
                  name={`${tableName}-selectAll`}
                  id={`${tableName}-selectAll`}
                  onChange={props.onSelectAll}
                  checked={props.allSelected}
                />
                <label
                  className="checkbox-label"
                  htmlFor={`${tableName}-selectAll`}
                ></label>
              </div>
            </div>
            <div className="table-cell fw-bold">
              {tableHeaders[rowElements[0]]}
            </div>
          </>
        ) : (
          <>
            <div className="table-cell"></div>
            <div className="table-cell">
              {hideSelectAll ? "" : tableHeaders[rowElements[0]]}
            </div>
          </>
        )}
        {rowElements.map(
          (el, idx) =>
            idx > 0 && (
              <div
                className={`table-cell fw-bold ${el}`}
                key={`header-cell-${idx}`}
              >
                {tableHeaders[el]}
              </div>
            )
        )}
      </div>
      {props.listOfRegs.map((reg, idx) => (
        <div
          className={`table-row ${reg.forbiddenSelect ? "row-disabled" : ""}`}
          key={`row-${tableName}-${idx}`}
        >
          {reg.forbiddenSelect ? (
            <div
              className="popover-element d-flex justify-content-center align-items-center"
              data-bs-toggle="popover"
              data-bs-placement="top"
              data-bs-trigger="hover"
              data-bs-boundary="window"
              id={`popover-${tableName}-${idx}`}
              data-bs-content={tooltipForbidden}
            >
              <ForbiddenIcon />
            </div>
          ) : selectOptionEnabled && !reg.hideSelectOption ? (
            <div className="table-cell">
              <div className="input-group">
                <input
                  type="checkbox"
                  name={`el-${tableName}-${idx}`}
                  id={`el-${tableName}-${idx}`}
                  value={reg.value || reg.id}
                  onChange={(e) => props.onSelectRow(e, reg)}
                  checked={reg.checked}
                />
                <label
                  className="checkbox-label"
                  htmlFor={`el-${tableName}-${idx}`}
                ></label>
              </div>
            </div>
          ) : (
            <div className="table-cell"></div>
          )}
          {rowElements.map((key) => (
            <div
              className={`table-cell ${key} ${
                reg.forbiddenSelect ? "disabled-cell" : ""
              }`}
              key={`cell-${idx}-${key}`}
            >
              {reg[key]}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default Table;

Table.propTypes = {
  hideSelectAll: PropTypes.bool,
  selectAllOptionEnabled: PropTypes.bool,
  selectOptionEnabled: PropTypes.bool,
  tableHeaders: PropTypes.shape({}).isRequired,
  rowElements: PropTypes.arrayOf(PropTypes.string).isRequired,
  listOfRegs: PropTypes.arrayOf(PropTypes.shape({})),
  tableName: PropTypes.string,
  tooltipForbidden: PropTypes.string,
};

Table.defaultProps = {
  selectAllOptionEnabled: false,
  hideSelectAll: false,
  selectOptionEnabled: false,
  listOfRegs: [],
  tooltipForbidden: "",
  tableName: "",
};
